var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.143 15.0339C10.7636 15.0778 10.3819 15.0998 10 15.0996C5.8024 15.0996 2.44 12.4869 1 8.79961C1.34863 7.90271 1.81959 7.05831 2.3995 6.29041M14.932 13.7325C16.768 12.612 18.19 10.8759 19 8.79961C17.56 5.11231 14.1976 2.49961 10 2.49961C8.26109 2.49043 6.55374 2.96401 5.068 3.86761M11.908 10.7076C12.1587 10.4569 12.3576 10.1592 12.4933 9.83159C12.629 9.50398 12.6989 9.15286 12.6989 8.79826C12.6989 8.44366 12.629 8.09253 12.4933 7.76493C12.3576 7.43732 12.1587 7.13965 11.908 6.88891C11.6573 6.63817 11.3596 6.43927 11.032 6.30357C10.7044 6.16787 10.3532 6.09803 9.99865 6.09803C9.64405 6.09803 9.29292 6.16787 8.96532 6.30357C8.63771 6.43927 8.34004 6.63817 8.0893 6.88891",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2031 16L2.80313 1.6",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideIcon);
export default __webpack_public_path__ + "static/media/HideIcon.17582388f9bd18ee301c2db7acfdec80.svg";
export { ForwardRef as ReactComponent };